/* dynamic-table.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isFixedSize", "hasDataRow", "children", "testId", "isLoading"];
import "./dynamic-table.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @repo/internal/react/require-jsdoc */

import { forwardRef } from 'react';
var fixedSizeTableStyles = null;
var tableStyles = null;
var bodyBorder = null;
export var Table = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isFixedSize = _ref.isFixedSize,
    hasDataRow = _ref.hasDataRow,
    children = _ref.children,
    testId = _ref.testId,
    isLoading = _ref.isLoading,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("table", _extends({
    inert: isLoading ? '' : undefined,
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CCE0FF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #388BFF)"
    },
    ref: ref
  }, rest, {
    "data-testid": testId && "".concat(testId, "--table"),
    className: ax(["_1bsb1osq _yq5hus1c _btyzidpf _ect41gqc", isFixedSize && "_1kqm1n9t", hasDataRow && "_179r187z"])
  }), children);
});
var captionStyles = null;
export var Caption = function Caption(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("caption", {
    className: ax(["_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"])
  }, children);
};
var paginationWrapperStyles = null;
export var PaginationWrapper = function PaginationWrapper(_ref3) {
  var children = _ref3.children,
    testId = _ref3.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId && "".concat(testId, "--pagination--container"),
    className: ax(["_1e0c1txw _1bah1h6o"])
  }, children);
};